/**
 * Created by koqiui on 2017-04-09.
 */
import { Vue, MsgBox } from '../../app.vues'
import { Utils } from '../../app.base'
//
import SwbMsuListForSelect from './MsuListForSelect';
Vue.regist(SwbMsuListForSelect);

import SwbServcForSelected from './ServcForSelected';
Vue.regist(SwbServcForSelected);

import SwbMsuListByGoodsCatIdAndServicerIdForSelect from './MsuListByGoodsCatIdAndServicerIdForSelect';
Vue.regist(SwbMsuListByGoodsCatIdAndServicerIdForSelect);

import SwbServcProprietaryAnddistForSelected from './ServcProprietaryAnddistForSelected';
Vue.regist(SwbServcProprietaryAnddistForSelected);

import SwbServcGoodsCatRelSelect from './ServcGoodsCatRelSelect.vue';
Vue.regist(SwbServcGoodsCatRelSelect);

import SwbEngineerSsuListForSelect from './EngineerSsuListForSelect';
Vue.regist(SwbEngineerSsuListForSelect);

export function openMsuListDlg(checkBox, proxied, servcType, callback, searchAuthServicer, comnOnlyFlag) {
    checkBox = Utils.isNoB(checkBox) ? false : checkBox;
    proxied = Utils.isNoB(proxied) ? true : proxied;
    //
    Vue.$showDialog({
        title: '服务-选择',
        width: 1200,
        height: 800,
        showCloseBtn: true,
        okVisible: true,
        template: '<swb-msu-list-for-select :checkBox = "checkBox" :proxied = "proxied" :type="servcType" :searchAuthServicer="searchAuthServicer" :comnOnlyFlag="comnOnlyFlag" ref="swb_msu_list_for_select"></swb-msu-list-for-select>',
        data: {
            checkBox: checkBox,
            proxied: proxied,
            servcType: servcType,
            searchAuthServicer: searchAuthServicer,
            comnOnlyFlag: comnOnlyFlag,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_msu_list_for_select.getDlgResult() || {};
            if(result.type == "info") {
                let itemInfo = result.data;
                //
                callback(itemInfo);
            } else {
                return false;
            }
        },
        lifecycle: {
            created: function () {
                this.checkBox = checkBox || false;
                this.proxied = Utils.isTrue(proxied);
            }
        },
    });
}
// 通用服务选择
export function openMsuListForSelectDlg(checkBox, params, callback) {
    checkBox = Utils.isNoB(checkBox) ? false : checkBox;
    let checkedIds = params["selectIds"] || [];
    let servcType = params["servcType"] || null;
    let filter = params["filter"] || {};
    //
    Vue.$showDialog({
        title: '服务-选择',
        width: '80%',
        height: 700,
        showCloseBtn: true,
        okVisible: true,
        template: '<div class = "">' +
        '<swb-msu-list-for-select :checkBox = "checkBox" :checkedIds = "checkedIds" :type="servcType" :filter="filter" ref="swb_msu_list_for_select"></swb-msu-list-for-select>' +
        '</div>',
        data: {
            checkBox: checkBox,
            checkedIds: checkedIds,
            servcType: servcType,
            filter: filter
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_msu_list_for_select.getDlgResult() || {};
            if(result.type == "info") {
                let itemInfo = result.data;
                //
                callback(itemInfo);
            } else {
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

export function openServcListForSelectDlg(goodsCatId, servcType, callback) {
    Vue.$showDialog({
        title: '服务-选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        okVisible: true,
        template: '<div>' +
        '<swb-servc-for-selected :goodsCatId="goodsCatId" :servcType="servcType" ref="swb_servc_for_selected"></swb-servc-for-selected>' +
        '</div>',
        data: {
            goodsCatId: goodsCatId,
            servcType: servcType
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_servc_for_selected.getDlgResult() || {};
            if(result.type == "info") {
                let servcInfo = result.data;
                //
                callback(servcInfo);
            } else {
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 根据 先根据goodsCatId 在根据 servcIds 过滤的 服务
export function openServcProprietaryAndDistListForSelectDlg(goodsCatId, servcIds, servcType, callback) {
    //
    Vue.$showDialog({
        title: '服务-选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        okVisible: true,
        template: '<div>' +
        '<swb-servc-proprietary-dist-for-selected :goodsCatId="goodsCatId" :engineerServcIds="engineerServcIds" :type="servcType" ref="swb_servc_proprietary_dist_for_selected"></swb-servc-proprietary-dist-for-selected>' +
        '</div>',
        data: {
            goodsCatId: goodsCatId,
            engineerServcIds: servcIds || [],
            servcType: servcType
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_servc_proprietary_dist_for_selected.getDlgResult() || {};
            if(result.type == "info") {
                let servcInfo = result.data;
                //
                callback(servcInfo);
            } else {
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 质保外服务选择列表
export function openMsuListByGoodsCatIdDlg(goodsCatId, servicerId, servcType, callback) {
    Vue.$showDialog({
        title: "服务选择列表",
        width: '80%',
        height: 600,
        showCloseBtn: true,
        template: '<div>' +
        '<swb-msu-list-by-goodsCatId-and-servicerId-for-select :goodsCatId="goodsCatId" :servicerId="servicerId" :type="type" ref="swb_msu_list_by_goodsCatId_and_servicerId_for_select"></swb-msu-list-by-goodsCatId-and-servicerId-for-select>' +
        '</div>',
        data: {
            goodsCatId: goodsCatId,
            servicerId: servicerId,
            type: servcType
        },
        methods: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_msu_list_by_goodsCatId_and_servicerId_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                let msu = result.data;
                callback(msu);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbMsuListByGoodsIdAndMerchantIdForSelect from './MsuListByGoodsIdAndMerchantIdForSelect';
Vue.regist(SwbMsuListByGoodsIdAndMerchantIdForSelect);
// 质保内服务选择列表
export function openMsuListByGoodsIdDlg(goodsId, srcVendorId, sellerType, servcType, callback) {
    let theDlg = Vue.$showDialog({
        title: "服务选择列表",
        width: 1000,
        height: 650,
        template: '<swb-msu-list-by-goodsId-and-merchantId-for-select :type="type" :goodsId="goodsId" :srcVendorId="srcVendorId" :sellerType="sellerType" ref="swb_msu_list_by_goodsId_and_merchantId_for_select"></swb-msu-list-by-goodsId-and-merchantId-for-select>',
        data: {
            goodsId: goodsId,
            srcVendorId: srcVendorId,
            sellerType: sellerType,
            type: servcType,
        },
        methods: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_msu_list_by_goodsId_and_merchantId_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                let msu = result.data;
                callback(msu);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbAuthOutMsuListForSelect from './AuthOutMsuListForSelect';
Vue.regist(SwbAuthOutMsuListForSelect);
// 授权出去的服务选择列表
export function showAuthOutMsuListForSelectDlg(dlgConfig, callback) {
    let title = dlgConfig["title"] || "授权服务 - 选择";
    let checkBox = dlgConfig["checkBox"] == null ? false : dlgConfig["checkBox"];
    let selectIds = dlgConfig["selectIds"] || [];
    let selectDisabled = Utils.isTrue(dlgConfig["selectDisabled"]);
    let filter = dlgConfig["filter"] || {};
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 900,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-auth-out-msu-list-for-select :checkBox="checkBox" :selectDisabled="selectDisabled" :selectIds="selectIds" :filter="filter" ref="swb_auth_out_msu_list_for_select"></swb-auth-out-msu-list-for-select>',
        data: {
            checkBox: checkBox,
            selectDisabled: selectDisabled,
            selectIds: selectIds,
            filter: filter
        },
        okClicked: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                let result = self.$refs.swb_auth_out_msu_list_for_select.getDlgResult() || {};
                if(result.type === 'info') {
                    let msuList = result.data || [];
                    callback(msuList, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            }, 0);
            return false;
        }
    });
}

export function selectRedioServcGoodsCatRel(servcId, callback) {
    //
    Vue.$showDialog({
        title: '服务商品分类-选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        okVisible: true,
        template: '<div>' +
        '<swb-servc-goods-cat-rel-list :servcId="servcId" ref="swb_servc_goods_cat_rel_list"></swb-servc-goods-cat-rel-list>' +
        '</div>',
        data: {
            servcId: servcId
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_servc_goods_cat_rel_list.getDlgResult() || {};
            if(result.type == "info") {
                let servcGoodsCatRel = result.data;
                //
                callback(servcGoodsCatRel);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

//工程师服务能力
export function selectEngineerServcDlg(checkedIds, servicerShopId, callback) {
    Vue.$showDialog({
        title: '工程师服务能力 - 选择',
        width: 1300,
        height: 800,
        showCloseBtn: true,
        template: '<div>' +
        '<swb-engineer-ssu-list-for-select :checkedIds="checkedIds" :servicerShopId="servicerShopId" ref="swb_engineer_ssu_list"></swb-engineer-ssu-list-for-select>' +
        '</div>',
        data: {
            servicerShopId: servicerShopId,
            checkedIds: checkedIds
        },
        methods: {},
        okClicked: function () {
            let selfDlg = this;
            let result = selfDlg.$refs.swb_engineer_ssu_list.getDlgResult() || {};
            if(result != null && result.type === 'info') {
                //
                callback(result);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbServcChargeItemList from './ServcChargeItemList';
Vue.regist(SwbServcChargeItemList);

export function showServcChargeItemList(params) {
    let msuId = params['msuId'] || null;
    Vue.$showDialog({
        title: '服务收费项',
        width: 900,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-servc-charge-item-list :msuId="msuId" ref="swb_servc_charge_item_list"></swb-servc-charge-item-list>',
        data: {
            msuId: msuId
        },
        methods: {},
        okClicked: function () {
        }
    });
}

import SwbServcFormatExpl from './ServcFormatExpl';
Vue.regist(SwbServcFormatExpl);
// 服务项目导入说明
export function openServcFormatExplDlg(scopeId) {
    //
    let theDlg = Vue.$showDialog({
        title: "服务项目导入说明 - 查看",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-servc-format-expl :scopeId="scopeId" ref="swb_goods_format_expl"></swb-servc-format-expl>' +
        '</div>',
        data: {
            scopeId: scopeId
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbServcImpCheck from './ServcImpCheck';
Vue.regist(SwbServcImpCheck);
// 服务项目导入检查
export function openServcImpCheckDlg(fileObj, callback) {
    let theDlg = null;
    theDlg = Vue.$showDialog({
        title: "服务项目导入 - 检查",
        width: -100,
        height: -50,
        okVisible: false,
        cancelVisible: false,
        extVisible: true,
        showCloseBtn: true,
        okText: '整体导入',
        extText: '关闭',
        cancelText: '整体检查',
        template: '<swb-servc-imp-check @other-close="otherClose" :rootWidth="dlgBodyWidth" :rootHeight="dlgBodyHeight" :fileObj="fileObj" ref="swb_servc_imp_check"></swb-servc-imp-check>',
        data: {
            fileObj: fileObj,
            dlgBodyWidth: 900,
            dlgBodyHeight: 680,
        },
        methods: {
            dlgBodyResized(width, height){
                this.dlgBodyWidth = width;
                this.dlgBodyHeight = height;
            },
            otherClose(){
                callback({
                    importStatis: null
                });
                theDlg.close();
            }
        },
        okClicked: function () {
            // let result = self.$refs.swb_servc_imp_check.getDlgResult() || {};
        },
        cancelClicked: function () {
        }
    });
}

import  SwbSpecServcSelect from './GrabServcSelect';
Vue.regist(SwbSpecServcSelect);
export function openGrabServcSelectDlg(params, callback) {
    Vue.$showDialog({
        title: "服务选择列表",
        width: 1200,
        height: 600,
        showCloseBtn: true,
        template: '<div>' +
        '<swb-grab-servc-select :paramsFilter="params" ref="swb_grab_servc_select"></swb-grab-servc-select>' +
        '</div>',
        data: {
            params: params
        },
        methods: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_grab_servc_select.getDlgResult() || {};
            if(result.type == 'info') {
                let msu = result.data;
                callback(msu);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/servc/selectDlg.js
// module id = 31
// module chunks = 1